import type { UIMessage } from "ai";

import { CONVERSATION_LIMIT_REACHED } from "@/features/Assistant/helpers/assistantErrorCode";

export type OrganizationErrorNotice =
  | "rateLimited"
  | "rateLimitedAfterCards"
  | "conversationLimit"
  | "retryLoading"
  | "generic";

const isAnsweredApprovalPart = (part: UIMessage["parts"][number]): boolean =>
  part.type.startsWith("tool-") && "state" in part && part.state === "approval-responded";

export const getOrganizationErrorNotice = ({
  errorCode,
  messages,
}: {
  errorCode: string | null;
  messages: UIMessage[];
}): OrganizationErrorNotice | null => {
  if (errorCode === null) {
    return null;
  }
  if (errorCode === CONVERSATION_LIMIT_REACHED) {
    return "conversationLimit";
  }
  const hasAnsweredCards = messages.at(-1)?.parts.some(isAnsweredApprovalPart) ?? false;
  if (errorCode === "rate_limited") {
    return hasAnsweredCards ? "rateLimitedAfterCards" : "rateLimited";
  }
  return hasAnsweredCards ? "retryLoading" : "generic";
};

export const isAwaitingReload = (notice: OrganizationErrorNotice | null): boolean =>
  notice === "retryLoading" || notice === "rateLimitedAfterCards";
